import { render, staticRenderFns } from "./RegistrarTurno.vue?vue&type=template&id=66c9e898"
import script from "./RegistrarTurno.vue?vue&type=script&lang=js"
export * from "./RegistrarTurno.vue?vue&type=script&lang=js"
import style0 from "./RegistrarTurno.vue?vue&type=style&index=0&id=66c9e898&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports